module.exports = __webpack_public_path__ + "static/media/portrait-near-green-leafed-plants.a477e88e.jpg";